export const BUSINESS_TOGGLE_COOKIE: string = 'IsBusinessEcommerce';
export const FAVORITE_STORES_COOKIE_NAME = 'Coop_Stores_Favorites';
export const RECIPE_RATINGS_COOKIE_NAME = 'Coop_Recipe_Rating';
export const FAVORITE_RECIPE_COOKIE_NAME: string = 'FavRecipe';
export const ALERTS_DISMISSED_COOKIE_PREFIX: string = 'AVC';
export const HYBRIS_ROUTE_COOKIE = 'h-route';
export const LOOP54_ANONYMOUS_USER_COOKIE = 'Loop54AnonymousUser';
export const FULL_SPA_MODE = 'Coop_FullSpaEnabled';
